(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Deep link into the grid: jump to the card named in the URL hash. */
  (() => {
    const url = new URL(window.location.href);
    if (!url.hash) return;

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  })();

  /* Card hover overlay: wishlist, view, and image cycling. */
  (() => {
    const MOUNTED = 'ympcMounted';

    /* The card's markup belongs to the theme, so the image wrapper is found
       rather than assumed: the closest thing around the first image that
       already behaves like a media box, falling back to its parent. */
    const findMedia = (item) => {
      const img = item.querySelector('img');
      if (!img) return null;

      return (
        img.closest('.product-media-container') ||
        img.closest('.card-gallery') ||
        img.closest('[class*="media"]') ||
        img.parentElement
      );
    };

    const readWishlist = (key) => {
      try {
        const stored = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(stored) ? stored : [];
      } catch (error) {
        return [];
      }
    };

    const writeWishlist = (key, items) => {
      try {
        localStorage.setItem(key, JSON.stringify(items));
      } catch (error) {
        // Storage can be full or blocked; the button state still updates.
      }

      window.dispatchEvent(
        new CustomEvent('custom:wishlist-updated', {
          detail: { items: items, count: items.length },
        })
      );
    };

    const toast = (message) => {
      document.querySelector('.custom-wishlist-toast')?.remove();

      const el = document.createElement('div');
      el.className = 'custom-wishlist-toast';
      el.textContent = message;
      document.body.appendChild(el);

      requestAnimationFrame(() => el.classList.add('is-visible'));

      window.setTimeout(() => {
        el.classList.remove('is-visible');
        window.setTimeout(() => el.remove(), 250);
      }, 2200);
    };

    const syncHearts = () => {
      document.querySelectorAll('[data-ympc]').forEach((overlay) => {
        const button = overlay.querySelector('[data-ympc-wishlist]');
        if (!button) return;

        const items = readWishlist(overlay.dataset.wishlistKey);
        const saved = items.some((item) => item.handle === overlay.dataset.handle);

        button.classList.toggle('is-active', saved);
        button.setAttribute('aria-pressed', saved ? 'true' : 'false');
        button.setAttribute(
          'aria-label',
          (saved ? 'Remove ' : 'Add ') + overlay.dataset.title + (saved ? ' from wishlist' : ' to wishlist')
        );
      });
    };

    const wireOverlay = (overlay) => {
      /* --- image cycling. Frame 0 is the card's own image, so the count is
         one more than the frames this overlay carries. --- */
      const frames = Array.from(overlay.querySelectorAll('[data-ympc-frame]'));
      const total = frames.length + 1;
      let index = 0;

      const show = (i) => {
        index = (i + total) % total;
        frames.forEach((frame, position) => {
          frame.classList.toggle('is-active', position + 1 === index);
        });
      };

      overlay.querySelector('[data-ympc-prev]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(index - 1);
      });

      overlay.querySelector('[data-ympc-next]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(index + 1);
      });

      /* --- wishlist --- */
      const heart = overlay.querySelector('[data-ympc-wishlist]');

      heart?.addEventListener('click', (event) => {
        // The card is one big link, so the click must not reach it.
        event.preventDefault();
        event.stopPropagation();

        const key = overlay.dataset.wishlistKey;
        const limit = parseInt(overlay.dataset.wishlistLimit, 10) || 15;
        const items = readWishlist(key);
        const existing = items.findIndex((item) => item.handle === overlay.dataset.handle);

        if (existing > -1) {
          items.splice(existing, 1);
          writeWishlist(key, items);
          syncHearts();
          toast('Removed from wishlist');
          return;
        }

        if (items.length >= limit) {
          toast('Your wishlist can hold up to ' + limit + ' products.');
          return;
        }

        items.unshift({
          id: overlay.dataset.id,
          handle: overlay.dataset.handle,
          title: overlay.dataset.title,
          url: overlay.dataset.url,
          image: overlay.dataset.image,
          addedAt: Date.now(),
        });

        writeWishlist(key, items);
        syncHearts();
        toast('Added to wishlist');
      });

      overlay.querySelector('[data-ympc-view]')?.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    };

    const mount = (root) => {
      const items = root.querySelectorAll('.product-grid__item');

      items.forEach((item) => {
        if (item.dataset[MOUNTED] === 'true') return;

        const template = item.querySelector('[data-ympc-template]');
        if (!template) return;

        const media = findMedia(item);
        if (!media) return;

        item.dataset[MOUNTED] = 'true';
        media.classList.add('ympc-media');

        const overlay = template.content.firstElementChild.cloneNode(true);
        media.appendChild(overlay);
        wireOverlay(overlay);
      });

      syncHearts();
    };

    const start = () => {
      document.querySelectorAll('results-list').forEach((list) => {
        mount(list);

        // Infinite scroll and filtering both replace the grid, so new cards
        // get the overlay as they arrive.
        if (list.dataset.ympcObserved === 'true') return;
        list.dataset.ympcObserved = 'true';

        new MutationObserver(() => mount(list)).observe(list, {
          childList: true,
          subtree: true,
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('storage', syncHearts);
    window.addEventListener('custom:wishlist-updated', syncHearts);
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-reviews]').forEach((root) => {
      if (root.dataset.prInit === 'true') return;
      root.dataset.prInit = 'true';

      const items = Array.from(root.querySelectorAll('[data-pr-item]'));
      const bars = Array.from(root.querySelectorAll('[data-filter]'));
      const more = root.querySelector('[data-pr-more]');
      const clear = root.querySelector('[data-pr-clear]');
      const showing = root.querySelector('[data-pr-showing]');
      const empty = root.querySelector('[data-pr-empty]');

      const perPage =
        parseInt(getComputedStyle(root).getPropertyValue('--pr-per-page'), 10) || 4;

      let filter = 0;
      let shown = perPage;

      const render = () => {
        const matching = items.filter(
          (item) => filter === 0 || Number(item.dataset.rating) === filter
        );

        items.forEach((item) => {
          item.hidden = true;
        });

        matching.slice(0, shown).forEach((item) => {
          item.hidden = false;
        });

        if (more) more.hidden = matching.length <= shown;
        if (empty) empty.hidden = matching.length > 0;
        if (clear) clear.hidden = filter === 0;

        if (showing) {
          const visible = Math.min(shown, matching.length);
          showing.textContent = matching.length
            ? 'Showing ' + visible + ' of ' + matching.length +
              (filter ? ' ' + filter + '-star reviews' : ' reviews')
            : '';
        }

        bars.forEach((bar) => {
          bar.setAttribute(
            'aria-pressed',
            Number(bar.dataset.filter) === filter ? 'true' : 'false'
          );
        });
      };

      bars.forEach((bar) => {
        bar.addEventListener('click', () => {
          const value = Number(bar.dataset.filter);
          // Tapping the active bar again clears it.
          filter = filter === value ? 0 : value;
          shown = perPage;
          render();
        });
      });

      clear?.addEventListener('click', () => {
        filter = 0;
        shown = perPage;
        render();
      });

      more?.addEventListener('click', () => {
        shown += perPage;
        render();
      });

      /* ---------------------------------------------------- the form */
      const overlay = root.querySelector('[data-pr-overlay]');

      if (overlay) {
        const open = () => {
          overlay.classList.add('is-open');
          overlay.setAttribute('aria-hidden', 'false');
          document.body.classList.add('pr-locked');
          overlay.querySelector('[data-pr-close]')?.focus();
        };

        const close = () => {
          overlay.classList.remove('is-open');
          overlay.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('pr-locked');
        };

        root.querySelectorAll('[data-pr-open]').forEach((button) => {
          button.addEventListener('click', open);
        });

        overlay.querySelector('[data-pr-close]')?.addEventListener('click', close);

        overlay.addEventListener('click', (event) => {
          if (event.target === overlay) close();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && overlay.classList.contains('is-open')) close();
        });

        // Shopify reloads the page after a contact form posts, so the
        // confirmation only shows if the dialog reopens itself.
        if (overlay.querySelector('.pr__form-success, .pr__form-error')) open();
      }

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-bar"] && !Shopify.designMode) return;
  try {
    
  class ServiceBar extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-drawn');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-drawn');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(this);
    }
  }

  if (!customElements.get('service-bar')) {
    customElements.define('service-bar', ServiceBar);
  }

  } catch(e) { console.error(e); }
})();
})();
